import {h, Component} from 'preact';
import {connect} from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import util from "../util";
import constants from '../constants';
import designDomain from '../domain/designDomain';
import designService from '../service/designService';
import tagService from '../service/tagService';
import categoryService from '../service/categoryService';
import Spinner from "./Spinner";
import {createPortal} from "preact/compat";

export default @connect(reduce, actions)
class ConfigureTemplateModal extends Component {

  constructor() {
    super();

    this.state = {
      isLoadingDetails: false,
      isMultiple: false,
      designs: [],

      designName: '',
      designStatus: '',
      pageTitle: '',
      url: '',
      description: '',
      metaDescription: '',

      tags: [],
      categories: [],
      tagsToRemove: [],
      catsToRemove: [],
      parent: '',
      designer: '',
      assignedTo: '',
      lastEditedDate: '',
      notes: '',
      createdDate: '',
      updatedDate: '',

      tagSuggestions: [],
      categorySuggestions: [],
      catToRemoveSuggestions: [],
      parentSuggestions: [],

      newCategoryName: '',
      newTagName: '',
      newTagToRemoveName: '',

      designers: [],

      oldName: '',
      oldNameSet: false,

      rank: '',

      free: false,

      designId: '',

      isSearching: false,
    };

    this.onChangeStatus = (event) => {
      const val = event.target.value;
      this.setState({designStatus: val});

      if (this.state.designId === this.props.designId) {
        this.props.setDesignStatus(val);
      }
    };

    this.saveOneOfMultiple = (design) => {
      designService.getDesign(design.id).then(resp => {
        const data = resp.data;
        let newCategories = this.state.categories.length > 0 ? data.categories.concat(this.state.categories) : data.categories;
        if (this.state.catsToRemove.length > 0) {
          newCategories = newCategories.filter(cat => !this.state.catsToRemove.map(catRemove => catRemove.id).includes(cat.id));
          if (newCategories.length === 0) {
            newCategories = [{}];
          }
        }
        let newTags = this.state.tags.length > 0 ? data.tags.concat(this.state.tags) : data.tags;
        if (this.state.tagsToRemove.length > 0) {
          newTags = newTags.filter(tag => !this.state.tagsToRemove.map(tagRemove => tagRemove.id).includes(tag.id));
        }
        let newRank = this.state.rank !== '' ? this.state.rank : data.rank;
        let newStatus = this.state.designStatus !== "false" ? this.state.designStatus : data.status;
        
        designService.updateDesign({
          id: design.id,
          categories: newCategories,
          tags: newTags,
          rank: newRank,
          status: newStatus
        }).then(resp => {
          this.props.setIsSaved(true);
          this.props.setIsSaving(false);

          if (this.props.promoDesigns.length > 0) {
            const thisDesign = this.props.promoDesigns.find(it => it.id === design.id);
            thisDesign.status = newStatus;
          }

          this.props.onModalClose();
        })
      })
    }

    this.save = () => {
      this.props.setIsSaved(false);
      this.props.setIsSaving(true);

      if (this.state.designs && this.state.designs.length > 0) {
        const $this = this;
        this.state.designs.forEach(function(design) {
          $this.saveOneOfMultiple(design);
        })
      } else {
        designService.updateDesign({
          id: this.state.designId,
          templateId: this.props.parentId,
          name: this.state.designName,
          pageTitle: this.state.pageTitle,
          url: this.state.url,
          description: this.state.description,
          metaDescription: this.state.metaDescription,
          status: this.state.designStatus,
          designer: this.state.designer,
          assignedTo: this.state.assignedTo,
          lastEditedDate: this.state.lastEditedDate,
          notes: this.state.notes,
          type: constants.template,
          tags: this.state.tags,
          categories: this.state.categories,
          linkedParent: this.state.parent ? this.state.parent.id : '',
          rank: this.state.rank,
          free: this.state.free,
        }).then(response => {
          let catchVar = response.data;
          
          this.props.setIsSaved(true);
          this.props.setIsSaving(false);

          this.setState({oldNameSet: false});

          if (this.props.promoDesigns.length > 0) {
            const design = this.props.promoDesigns.find(it => it.id === this.state.designId);
            design.status = this.state.designStatus
          }

          this.props.onModalClose();
        }).catch((err) => {            
          this.props.setDesignName(this.state.oldName);
          this.setState({oldNameSet: false});
          this.props.setIsSaving(false);
          if (err.message.includes('properties of undefined')) {
            window.InfoModal.show({title: 'Failed to save', body: 'This design name is already in use!'});
            return;
          }
          window.InfoModal.show({
            title: 'Whoops!',
            body: 'We failed to save your work. Please try again later!',
            acceptLabel: 'Got it',
          });
        })
      }
    };

    this.preview = () => {
      const friendly = this.state.url ? this.state.url : this.props.designId;
      let win = window.open(constants.urlPrefix + '/templates/flyers/' + friendly + '.html', '_blank');
      win.focus();
    };

    this.onChangeName = (ev) => {
      this.setState({designName: ev.target.value})
      if (!this.state.oldNameSet) {
        this.setState({oldNameSet: true, oldName: this.state.designName})
      }
      if (this.state.designId === this.props.designId) {
        this.props.setDesignName(event.target.value)
      }
    };

    this.onChangePageTitle = (ev) => {
      this.setState({pageTitle: ev.target.value})
    };

    this.onChangeDetails = (ev) => {
      this.setState({description: ev.target.value})
    };

    this.onChangeMetaDescription = (ev) => {
      this.setState({metaDescription: ev.target.value})
    };

    this.onChangeDesigner = (ev) => {
      this.setState({designer: ev.target.value})
    };

    this.onChangeAssignedTo = (ev) => {
      this.setState({assignedTo: ev.target.value})
    };

    this.onChangeNotes = (ev) => {
      this.setState({notes: ev.target.value})
    };

    this.removeTag = (tag) => {
      this.setState({tags: this.state.tags.filter(t => t.id !== tag.id)})
    };

    this.removeTagToRemove = (tag) => {
      this.setState({tagsToRemove: this.state.tagsToRemove.filter(t => t.id !== tag.id)})
    };

    this.addTag = (tag) => {
      const found = this.state.tags.find(t => t.id === tag.id);
      if (found) return;

      this.setState(prev => ({
        tags: [tag, ...prev.tags],
        tagSuggestions: [],
        newTagName: ''
      }));
    };

    this.addTagToRemove = (tag) => {
      const found = this.state.tagsToRemove.find(t => t.id === tag.id);
      if (found) return;

      this.setState(prev => ({
        tagsToRemove: [tag, ...prev.tagsToRemove],
        tagSuggestions: [],
        newTagName: ''
      }));
    };

    this.createTag = (tag, toRemove=false) => {
      let name = '';
      if (toRemove) {
        name = tag || this.state.newTagToRemoveName;
      } else {
        name = tag || this.state.newTagName;
      }
      const dto = [];
      if (name.indexOf(',') > -1) {
        name.split(',').forEach(it => {
          dto.push({name: it.trim()});
        })
      } else {
        dto.push({name});
      }
      tagService.createTag(dto).then(resp => {
        if (toRemove) {
          resp.data.forEach(it => this.addTagToRemove(new designDomain.Tag(it)));
        } else {
          resp.data.forEach(it => this.addTag(new designDomain.Tag(it)));
        }
      });
    };

    this.updateNewTagName = (ev) => {
      this.setState({newTagName: ev.target.value});
    };

    this.updateNewTagToRemoveName = (ev) => {
      this.setState({newTagToRemoveName: ev.target.value});
    };

    this.onNewTagKeyUp = (ev, toRemove=false) => {
      if (ev.keyCode === 13) {
        const value = ev.keyCode === 188 ? ev.target.value.slice(0, -1) : ev.target.value;
        this.createTag(value, toRemove);
        this.resetNewTag();
      }
    };

    this.removeCategory = (category, toRemove=false) => {
      if (toRemove) {
        this.setState({catsToRemove: this.state.catsToRemove.filter(c => c.id !== category.id)});
      } else {
        this.setState({categories: this.state.categories.filter(c => c.id !== category.id)});
      }
    };

    this.addCategory = (category, toRemove=false) => {
      let found = false;
      if (toRemove) {
        found = this.state.catsToRemove.find(c => c.id === category.id);
      } else {
        found = this.state.categories.find(c => c.id === category.id);
      }
      if (found) return;

      if (toRemove) {
        this.setState({
          catsToRemove: [category, ...this.state.catsToRemove],
          catToRemoveSuggestions: [],
          newCategoryName: ''
        })
      } else {
        this.setState({
          categories: [category, ...this.state.categories],
          categorySuggestions: [],
          newCategoryName: ''
        });
      }
    };

    this.onNewCategoryKeyUp = (ev, toRemove) => {
      this.fetchCategorySuggestions(ev.target.value, toRemove)
    };

    this.removeLinkedParent = () => {
      this.setState(() => ({parent: ''}));
    };

    this.addLinkedParent = (parent) => {
      this.setState(() => ({
        parent: parent,
        parentSuggestions: [],
      }));
    };

    this.onParentLinkKeyUp = (ev) => {
      this.fetchParentSuggestions(ev.target.value)
    };

    this.fetchParentSuggestions = (name) => {
      if (name.length > 1) {
        const filters = {
          page: 0,
          pageSize: 10000,
          search: name,
          orderBy: 'name',
          status: '',
        };

        designService.getTemplates(filters).then(response => {
          const suggestions = response.data.map(design => {
            return {name: design.name, id: design.id}
          });
          this.setState({
            parentSuggestions: suggestions
          });
        })
      }
    };

    this.fetchCategorySuggestions = (name, toRemove) => {
      if (name.length > 1) {
        categoryService.findCategories(name).then(response => {
          const categories = response.data.map(category => new designDomain.Category(category));
          if (!toRemove) {
            this.setState({
              categorySuggestions: categories
            });
          } else {
            this.setState({
              catToRemoveSuggestions: categories
            });
          }
        })
      }
    };

    this.resetNewTag = () => {
      this.setState({
        newTagName: '',
        newTagToRemoveName: '',
        tagSuggestions: []
      });
    };

    this.resetNewCategory = () => {
      this.setState({
        newCategoryName: '',
        categorySuggestions: [],
        catToRemoveSuggestions: []
      });
    };

    this.onChangeRank = (ev) => {
      this.setState({rank: ev.target.value});
    };

    this.onChangeFree = (event) => {
      this.setState({free: event.target.value});
    };

    this.alignLeft = () => {
      $('.config-modal').css('margin', '0 auto 0 2%')
    };

    this.alignCenter = () => {
      $('.config-modal').css('margin', '0 auto');
    };

    this.alignRight = () => {
      $('.config-modal').css('margin', '0 2% 0 auto')
    }
  }

  componentDidMount() {
    if (!!this.props.designId) this.init();
  }

  init(designToConfigure, multipleDesigns = []) {
    this.setState({isLoadingDetails: true,
              isMultiple: false,
              designs: []});

    if (multipleDesigns.length === 0) {
      let designId = designToConfigure ? designToConfigure : this.props.designId;

      this.setState({designId: designId});

      designService.getDesign(designId, true).then(response => {
        const data = response.data;

        this.setState({
          designName: data.name,
          designStatus: data.status,
          pageTitle: data.pageTitle,
          description: data.description,
          metaDescription: data.metaDescription,
          tags: data.tags || [],
          categories: data.categories || [],
          privacy: data.privacy,
          url: data.url,
          designer: data.designer,
          assignedTo: data.assignedTo,
          lastEditedDate: data.lastEditedDate,
          notes: data.notes,
          rank: data.rank || 9, // default rank,
          free: data.free || false, // default pro,
          createdDate: data.createdDate ? new Date(data.createdDate).toLocaleString() : '',
          updatedDate: data.updatedDate ? new Date(data.updatedDate).toLocaleString() : '',
          parent: data.linkedParent ? {name: data.linkedParentName, id: data.linkedParent} : '',
        });

        this.setState({isLoadingDetails: false});
      }).catch(err => {
        console.error(err);
        window.location = constants.appPrefix;
      });

      if (this.state.designers.length === 0) {
        designService.getDesigners().then(response => {
          this.setState({designers: response.data})
        });
      }
    } else {
      this.setState({ 
        isMultiple: true, 
        designs: multipleDesigns,
        designStatus: "false",
        tags: [],
        categories: [],
        rank: '' });
      this.setState({isLoadingDetails: false});
    }
  }

  render({open, designToConfigure, onModalClose, selectedDesigns = [], into = 'body', children, isAdmin},
         {
           name, pageTitle, url, description, metaDescription, tags, tagsToRemove, privacy, newTagName, newTagToRemoveName, tagSuggestions, designer,
           assignedTo, lastEditedDate, notes, categories, catsToRemove, newCategoryName, categorySuggestions, catToRemoveSuggestions, parent, parentSuggestions, rank, designId, designName,
           designStatus, isLoadingDetails, createdDate, updatedDate, free, isMultiple, designs
         }) {

    if (designToConfigure && designToConfigure !== designId) {
      this.init(this.props.designToConfigure);
    }

    if (selectedDesigns.length > 0 && designs !== selectedDesigns) {
      this.init(null, this.props.selectedDesigns);
    }

    tags.sort((a, b) => a.name.localeCompare(b.name));

    const tagElements = tags.map(tag => {
      return (
        <div className="tag">
          {tag.name}
          <a className="remove" onClick={() => this.removeTag(tag)}>x</a>
        </div>
      )
    });

    tagsToRemove.sort((a, b) => a.name.localeCompare(b.name));

    const removeTagElements = tagsToRemove.map(tag => {
      return (
        <div className="tag">
          {tag.name}
          <a className="remove" onClick={() => this.removeTagToRemove(tag)}>x</a>
        </div>
      )
    });

    const suggestionElements = tagSuggestions.map(suggestion => {
      return (
        <li className="suggestion">
          <a onClick={() => this.addTag(suggestion)}>{suggestion.name}</a>
        </li>
      )
    });

    let suggestions = null
    if (tagSuggestions.length > 0) {
      suggestions = <div className="suggestions">{suggestionElements}</div>
    } else if (newTagName.length > 0) {
      suggestions = <div className="new-tag"><a onClick={() => this.createTag()}>+ Create Tag</a></div>
    }

    const removeSuggestionElements = tagSuggestions.map(suggestion => {
      return (
        <li className="suggestion">
          <a onClick={() => this.addTagToRemove(suggestion)}>{suggestion.name}</a>
        </li>
      )
    });
    
    let removeSuggestions = null
    if (tagSuggestions.length > 0) {
      suggestions = <div className="suggestions">{removeSuggestionElements}</div>
    }

    const categoryElements = categories.map(category => {
      return (
        <div className="tag">
          {category.name}
          <a className="remove" onClick={() => this.removeCategory(category)}>x</a>
        </div>
      )
    });

    const categorySuggestionElements = categorySuggestions.map(category => {
      return (
        <li className="suggestion">
          <a onClick={() => this.addCategory(category)}>{category.name}</a>
        </li>
      )
    });

    let catSuggestions = null;
    if (categorySuggestions.length > 0) {
      catSuggestions = <div className="suggestions">{categorySuggestionElements}</div>
    }

    const removeCatElements = catsToRemove.map(category => {
      return (
        <div className="tag">
          {category.name}
          <a className="remove" onClick={() => this.removeCategory(category, true)}>x</a>
        </div>
      )
    });

    const removeCatSuggestionElements = catToRemoveSuggestions.map(category => {
      return (
        <li className="suggestion">
          <a onClick={() => this.addCategory(category, true)}>{category.name}</a>
        </li>
      )
    });

    let removeCatSuggestions = null;
    if (removeCatSuggestionElements.length > 0) {
      removeCatSuggestions = <div className="suggestions">{removeCatSuggestionElements}</div>
    }

    const statusOptions = constants.statuses.map(status =>
      <option value={status.id} className={!isAdmin && status.forAdmin ? 'hidden' : ''}>{status.label}</option>
    );

    const designersOptions = this.state.designers.length > 0 ? this.state.designers.map(designer =>
      <option value={designer}>{designer}</option>
    ) : '';

    const loadingSpinner = isLoadingDetails ? <Spinner/> : null;

    return open ? createPortal(<div>
      <div class="modal-back transparent" onClick={onModalClose}></div>
      <div className="modal config-modal">
        <a className="close" onClick={onModalClose}>
          <svg>
            <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-close"}/>
          </svg>
        </a>

        {loadingSpinner}

        <header>
          {!this.state.isMultiple && <h2>Configure Template</h2>}
          {this.state.isMultiple && <h2>Configure Templates</h2>}
        </header>

        <div className="aligns" style="display: inline-block; float: right; margin-top: -27px; margin-right: 10px;">
          <a style="cursor: pointer" onClick={this.alignLeft}>
            <svg>
              <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-multi-align-left"}/>
            </svg>
          </a>
          <a style="cursor: pointer" onClick={this.alignCenter}>
            <svg>
              <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-multi-align-center-vertical"}/>
            </svg>
          </a>
          <a style="cursor: pointer" onClick={this.alignRight}>
            <svg>
              <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-multi-align-right"}/>
            </svg>
          </a>
        </div>

        <div className="content">
          {!this.state.isMultiple &&
          <div className="form-block">
            <label>Name</label>
            <input type="text"
                   placeholder="Name..."
                   value={designName}
                   onBlur={this.onChangeName}
                   onClick={this.onChangeName}/>
          </div>}
          
          {!this.state.isMultiple &&
          <div className="form-block">
            <label>Link to parent design</label>

            <div className="tags">
              {!!parent && <div className="tag">{parent.name}<a className="remove" onClick={() => this.removeLinkedParent(parent)}>x</a></div>}
            </div>
            <input type="text" placeholder="Parent design..." onKeyUp={util.debounce(this.onParentLinkKeyUp)}/>

            <div className="suggestions">
              {parentSuggestions.map(it => (
                <li className="suggestion" key={it.name}>
                  <a onClick={() => this.addLinkedParent(it)}>{it.name}</a>
                </li>
              ))}
            </div>
          </div>}

          {!this.state.isMultiple &&
          <div className="form-block">
            <label>Details</label>
            <textarea className="expand"
                      value={description}
                      onBlur={this.onChangeDetails}
                      onClick={this.onChangeDetails}>
                                        Description...
                                    </textarea>
          </div>}

          {!this.state.isMultiple &&
          <div className="form-block">
            <label>Meta Description</label>
            <textarea className="expand"
                      value={metaDescription}
                      onBlur={this.onChangeMetaDescription}
                      onClick={this.onChangeMetaDescription}>
                                        Description...
                                    </textarea>
          </div>}

          <div className="form-block">
            <label>Tags</label>

            <div className="tags">{tagElements}</div>
            <input type="text"
                   placeholder="Tag name..."
                   value={newTagName}
                   onChange={this.updateNewTagName}
                   onKeyUp={this.onNewTagKeyUp}/>
            {suggestions}
          </div>

          {this.state.isMultiple &&
          <div className="form-block">
            <label>Tags to Remove</label>

            <div className="tags">{removeTagElements}</div>
            <input type="text"
                  placeholder="Tag name..."
                  value={newTagToRemoveName}
                  onChange={this.updateNewTagToRemoveName}
                  onKeyUp={(ev) => this.onNewTagKeyUp(ev, true)}/>
            {removeSuggestions}
          </div>}

          <div className="form-block">
            <label>Categories</label>

            <div className="tags">{categoryElements}</div>
            <input type="text"
                   placeholder="Category name..."
                   onKeyUp={(ev) => this.onNewCategoryKeyUp(ev, false)}/>
            {catSuggestions}
          </div>

          {this.state.isMultiple &&
          <div className="form-block">
            <label>Categories to Remove</label>

            <div className="tags">{removeCatElements}</div>
            <input type="text"
                   placeholder="Category name..."
                   onKeyUp={(ev) => this.onNewCategoryKeyUp(ev, true)}/>
            {removeCatSuggestions}
          </div>}

          {!this.state.isMultiple &&
          <div className="form-block">
            <label>Pro / Print</label>

            <select value={free} onChange={this.onChangeFree}>
              <option value={true}>Print</option>
              <option value={false}>Pro</option>
            </select>
          </div>}

          <div className="form-block">
            <label>Status</label>
            <select value={designStatus} onChange={this.onChangeStatus}>
              {this.state.isMultiple && <option value={false}>(Previously Set)</option>}
              {statusOptions}
            </select>
          </div>

          {!this.state.isMultiple &&
          <div className="form-block">
            <label>Built by</label>
            <select value={designer} onChange={this.onChangeDesigner}>
              {designersOptions}
            </select>
          </div>}

          {!this.state.isMultiple &&
          <div className="form-block">
            <label>Assigned to</label>
            <select value={assignedTo} onChange={this.onChangeAssignedTo}>
              <option value="none" selected>None</option>
              {designersOptions}
            </select>
          </div>}

          {!this.state.isMultiple &&
          <div className="form-block">
            <label>Notes</label>
            <textarea className="expand"
                      value={notes}
                      onBlur={this.onChangeNotes}
                      onClick={this.onChangeNotes}>
                                    </textarea>
          </div>}

          <div className="form-block">
            <label>Rank</label>
            <input type="text"
                   placeholder="Rank..."
                   value={rank}
                   onBlur={this.onChangeRank}
                   onClick={this.onChangeRank}/>
          </div>

          {!this.state.isMultiple &&
          <div className="form-block">
            <div style="width: 50%; display: inline-block;">
              <label>Create Date</label>
              <span><strong>{createdDate}</strong></span>
            </div>

            <div style="width: 50%; display: inline-block;">
              <label>Last Update</label>
              <span><strong>{updatedDate}</strong></span>
            </div>
          </div>}

          <footer>
            <a className="btn primary" onClick={() => this.save()}>
              {!this.props.isSaving && <span>Save</span>}
              {this.props.isSaving && <Spinner/>}
            </a>
            {!this.state.isMultiple &&
            <a className="btn preview pull-right" onClick={() => this.preview()}>Preview</a>}
          </footer>
        </div>
      </div>
    </div>, document.getElementById('modals')) : null;
  }
}
